import Vue from "vue";
import VueMarkdownIt from "vue-markdown-it";

import ShortcutComponent from "@/components/parent/shortcut/shortcut";
import shortcutComponent from "@/components/parent/shortcut/shortcut.vue";
import { Component, Prop } from "@/decorators";

import "./datatooltip.scss";

@Component({
    components: {
        shortcutComponent,
        VueMarkdownIt,
    },
})
export default class DataTooltipComponent extends Vue {
    @Prop(String) text: string;
    @Prop({ type: String, default: "fa-info-circle" }) icon: string;
    @Prop({ type: String, default: "#2196f3" }) iconColor: string;
    @Prop({ type: Boolean, default: false }) showModalOnClick: boolean;
    @Prop({ type: String, default: "" }) modalText: string;

    private shortCutComponent: ShortcutComponent = null;
    tooltipVisible = true;

    public async open() {
        this.hideTooltip();
        this.modalText = this.modalText.replace(/ {2,}/g, " ");
        this.shortCutComponent = this.$refs.shortCutComponent as ShortcutComponent;
        this.shortCutComponent.title = this.$t("__.Components.parent.venda.vendaForm_vue_html.detalhes") as string;
        this.shortCutComponent.show();
    }

    private showTooltip() {
        this.tooltipVisible = true;
    }

    private hideTooltip() {
        this.tooltipVisible = false;
    }
}
